<template>
  <div id="app">



    <div class="">
      <router-view 
        :auth="auth" 
        :authenticated="authenticated">
      </router-view>
    </div>

    

    <notifications group="foo" position="bottom right" />

  </div>
</template>

<script>
import AuthService from './auth/AuthService'
import {RotateSquare2} from 'vue-loading-spinner'

const auth = new AuthService()

const { login, logout, authenticated, authNotifier } = auth

export default {
  name: 'app',
  data () {
    authNotifier.on('authChange', authState => {
      this.authenticated = authState.authenticated
    })
    return {
      auth,
      authenticated
    }
  },
  components: {
    RotateSquare2
  },
  methods: {
    login,
    logout,
    getHotels () {
      this.$http
        // .get('http://srv5.ghosted.it:8000/authorized', {}).then((data) => {
        .get('http://localhost:44534'
        // {
        //   headers: {
        //     'Authorization': 'Bearer ' + localStorage.token
        //   },
        //   access_token: localStorage.access_token
        // }
        ).then((data) => {
          console.log('api good')
        }, (error) => {
          this.$notify({
            group: 'foo',
            title: 'Important message',
            text: 'Hello user! This is a notification!',
            type: 'error'
          })
          console.log(error)
        })
    }
  },
  beforeMount () {
    // this.getHotels()
  }
}
</script>

<style>
@import 'assets/font-awesome-4.7.0/css/font-awesome.css';
/*@import '../node_modules/bootstrap/dist/css/bootstrap.css';*/
@import 'assets/css/blocco.css';
@import 'assets/css/app.css';
@import 'assets/css/grid.css';
</style>


// WEBPACK FOOTER //
// src/App.vue